

const Projects = () => {
  const projects = [
    {
      id: 1,
      industry: 'EV',
      location: 'India',
      title: 'EV Manufacturing',
      description: 'Financial Modeling & Pitch Deck for $10M roadshow including investor targeting and deal financing strategy.',
      tags: ['Financial Modeling', 'Pitch Deck', 'Investor Targeting'],
      amount: '$10M Roadshow'
    },
    {
      id: 2,
      industry: 'E-Commerce',
      location: 'India',
      title: 'E-Commerce Platform',
      description: 'Prepared a full investment marketing suite, including pitch, IM, and VC shortlist, for fundraising readiness.',
      tags: ['Financial Model', 'Pitch Deck', 'IM'],
      amount: 'Series A'
    },
    {
      id: 3,
      industry: 'Energy',
      location: 'USA',
      title: 'Oilfield Company',
      description: 'Developed a custom debt model with layered financing structures to support a U.S. roadshow for capital access.',
      tags: ['Debt Advisory', 'Financial Modeling'],
      amount: 'Debt Financing'
    },
    {
      id: 4,
      industry: 'Real Estate',
      location: 'USA',
      title: 'Real Estate Fund',
      description: 'Built DCF models for 10+ projects with fund-level calculations for performance forecasting and investor reporting.',
      tags: ['DCF Valuation', 'Portfolio Modeling'],
      amount: 'Fund Management'
    },
    {
      id: 5,
      industry: 'Mobility',
      location: 'Singapore',
      title: 'E-Mobility Brand',
      description: 'Delivered a compelling investor deck for VC approval, focusing on return metrics and exit planning.',
      tags: ['Pitch Deck', 'VC Strategy'],
      amount: 'Seed Funding'
    },
    {
      id: 6,
      industry: 'Fintech',
      location: 'India',
      title: 'Alt Investment Platform',
      description: 'Crafted a strategic plan aligning growth objectives with operational roadmap and fundraising goals.',
      tags: ['Business Plan', 'Strategic Planning'],
      amount: 'Pre-Series A'
    },
    {
      id: 7,
      industry: 'Logistics',
      location: 'India',
      title: 'Logistics Firm',
      description: 'Prepared all investor documentation for a $30M raise, including targeted VC outreach and capital strategy.',
      tags: ['Financial Model', 'Pitch Deck', 'IM'],
      amount: '$30M Raise'
    },
    {
      id: 8,
      industry: 'Private Equity',
      location: 'USA',
      title: 'PE Acquisition',
      description: 'Conducted full financial diligence on a plumbing company for a Private Equity buyout transaction.',
      tags: ['M&A', 'Due Diligence'],
      amount: 'Buyout Transaction'
    },
    {
      id: 9,
      industry: 'Consumer',
      location: 'UAE',
      title: 'Consumer Brand',
      description: 'Designed VC presentation materials with exit scenarios and return optimization.',
      tags: ['Investor Deck', 'Exit Strategy'],
      amount: 'Growth Round'
    },
    {
      id: 10,
      industry: 'Industrial',
      location: 'USA',
      title: 'Industrial Conglomerate',
      description: 'Produced a comprehensive IM for the 100% strategic sale of a 4-entity industrial group.',
      tags: ['IM Preparation', 'M&A'],
      amount: 'Strategic Sale'
    },
    {
      id: 11,
      industry: 'Fintech',
      location: 'India',
      title: 'Fintech Startup',
      description: 'Built a Series A pitch deck tailored for banking & NBFC integrations to support investor outreach.',
      tags: ['Pitch Deck', 'Banking Integration'],
      amount: 'Series A'
    },
    {
      id: 12,
      industry: 'Landscaping',
      location: 'USA',
      title: 'Landscaping Firm',
      description: 'Developed a dynamic model for cash flow planning and capital raise execution.',
      tags: ['Financial Model', 'Cash Flow'],
      amount: 'Growth Capital'
    },
    {
      id: 13,
      industry: 'F&B',
      location: 'India',
      title: 'Waffle Franchise',
      description: 'Designed a high-growth deck for franchise scaling and investor onboarding.',
      tags: ['Pitch Deck', 'Franchise'],
      amount: 'Series B'
    },
    {
      id: 14,
      industry: 'Fashion Tech',
      location: 'USA',
      title: 'Cloth Rental App',
      description: 'Created a valuation-ready model with detailed revenue forecasts and scenario analysis.',
      tags: ['Financial Model', 'DCF'],
      amount: 'Valuation'
    },
    {
      id: 15,
      industry: 'Education',
      location: 'USA',
      title: 'Ed-Tech Institute',
      description: 'Conducted market-based valuation using precedent transactions and peer benchmarking.',
      tags: ['Valuation', 'Market Analysis'],
      amount: 'Acquisition'
    },
    {
      id: 16,
      industry: 'Furniture Tech',
      location: 'USA',
      title: 'AI Chair Manufacturer',
      description: 'Prepared investor documents for AI-integrated furniture tech firm seeking seed capital.',
      tags: ['Financial Model', 'Pitch Deck'],
      amount: 'Seed Round'
    },
    {
      id: 17,
      industry: 'E-Commerce',
      location: 'USA',
      title: 'Fashion Marketplace',
      description: 'Built growth projections and valuation for a marketplace with omni-channel revenue.',
      tags: ['DCF', 'Growth Projections'],
      amount: 'Series C'
    },
    {
      id: 18,
      industry: 'Luxury',
      location: 'USA',
      title: 'Luxury E-Commerce',
      description: 'Delivered multi-scenario models for international expansion planning.',
      tags: ['Financial Modeling', 'Scenario Analysis'],
      amount: 'Expansion'
    },
    {
      id: 19,
      industry: 'Fintech',
      location: 'USA',
      title: 'Fintech Company',
      description: 'Built a machine-learning driven model that adapts revenue KPIs and CAC payback dynamically.',
      tags: ['AI Modeling', 'Dynamic Forecasting'],
      amount: 'Series B'
    },
    {
      id: 20,
      industry: 'Gaming',
      location: 'USA',
      title: 'Gaming App',
      description: 'Created investor-grade valuation based on LTV, churn, and user growth models.',
      tags: ['DCF', 'LTV Analysis'],
      amount: 'Valuation'
    },
    {
      id: 21,
      industry: 'Energy',
      location: 'USA',
      title: 'Oil & Gas Player',
      description: 'Performed market-based pricing for reserves and asset transaction benchmarking.',
      tags: ['Valuation', 'Asset Pricing'],
      amount: 'Transaction'
    },
    {
      id: 22,
      industry: 'Esports',
      location: 'India',
      title: 'Esports Company',
      description: 'Prepared IM for strategic exit, including business snapshot, IP value, and projections.',
      tags: ['IM', 'Exit Strategy'],
      amount: 'Strategic Exit'
    },
    {
      id: 23,
      industry: 'Healthcare',
      location: 'USA',
      title: 'Healthcare Acquisition',
      description: 'Led financial diligence for PE firm acquiring a national chiropractic chain.',
      tags: ['Due Diligence', 'QoFE'],
      amount: 'PE Buyout'
    }
  ];

  return (
    <div className="pt-32 pb-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#0F172A] mb-6">Our Case Studies Portfolio</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Case studies of our financial advisory engagements across industries and geographies.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <div key={project.id} className="bg-gray-50 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition duration-300 hover:-translate-y-1">
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <span className="bg-[#3B82F6]/10 text-[#3B82F6] px-3 py-1 rounded-full text-sm font-medium mr-3">
                    {project.industry}
                  </span>
                  <span className="text-sm text-gray-500">{project.location} • {project.amount}</span>
                </div>
                <h3 className="text-xl font-semibold text-[#0F172A] mb-3">{project.title}</h3>
                <p className="text-gray-600 mb-4">{project.description}</p>
                <div className="flex flex-wrap gap-2">
                  {project.tags.map((tag, index) => (
                    <span key={index} className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        
      </div>
    </div>
  );
};

export default Projects;